import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import useOutsideElement from 'components/Dashboard/utilities/useOutsideElement';

const DropdownComponent = (props) => {
  const {
    items,
    mainItem,
    mainItemClass,
    overlapContent,
    notCloseOnSelect,
    fixedDropdown,
    children,
    disabled,
    nextIcon,
    hideArrowDisabled,
    dropdownClass = '',
    fixedTopSpace = 0,
    scrollBarPosition,
    waitOnOpen = true,
    conditionsToClose = [],
    openState,
    fixedRightSpace = 0,
    openToRight,
  } = props;

  const [showDropdown, setShowDropdown] = useState(false);
  const [cutAtBottom, setCutAtBottom] = useState(false);
  const [dropdownStyles, setDropdownStyles] = useState({ top: 0, left: 0, opacity: 0 });

  const dropdownElement = useRef(null);
  const mainItemElement = useRef(null);
  const optionsElement = useRef(null);
  const hideDropdown = () => {
    setShowDropdown(false);
  };
  useOutsideElement(dropdownElement, hideDropdown);
  const [dropdownDimentions, setDropdownDimentions] = useState({ top: 0, width: 0 });
  const dropdownElementWidth = dropdownElement?.current?.getBoundingClientRect()?.width;
  const createDimentions = useRef(null);

  createDimentions.current = () => {
    let node = dropdownElement.current;
    if (node !== null) {
      const optionsHeight = optionsElement?.current?.getBoundingClientRect().height;
      const top = node.getBoundingClientRect().top + node.getBoundingClientRect().height - 2;
      const cutAtBottom = top + optionsHeight > window.innerHeight;
      const distanceToBottom = window.innerHeight - (top + 40);
      setCutAtBottom(cutAtBottom);
      setDropdownDimentions({
        top: cutAtBottom ? node.getBoundingClientRect().top - optionsHeight : top + 1,
        width: node.getBoundingClientRect().width,
        left: node?.getBoundingClientRect()?.left,
        maxHeight: distanceToBottom < 300 ? `${distanceToBottom}px` : 'none',
      });
    }
  };

  useEffect(() => {
    if (!notCloseOnSelect) {
      setShowDropdown(false);
    }
  }, [mainItem, ...conditionsToClose]);

  useEffect(() => {
    //AE: To wait the popup appears and get the correct position
    if (waitOnOpen) {
      setTimeout(() => {
        createDimentions.current();
      }, 300);
    } else {
      createDimentions.current();
    }
    window.addEventListener('resize', createDimentions.current);
    return () => {
      window.removeEventListener('resize', createDimentions.current);
    };
  }, [showDropdown]);

  useEffect(() => {
    if (!!scrollBarPosition || dropdownElementWidth) {
      createDimentions.current();
      setShowDropdown(false);
    }
  }, [scrollBarPosition, dropdownElementWidth]);

  useState(() => {
    setTimeout(() => {
      if (openState) {
        setShowDropdown(true);
      }
    }, 50);
  }, [openState]);

  useLayoutEffect(() => {
    if (showDropdown) {
      const createStyles = () => {
        let styles;
        if (fixedDropdown) {
          styles = {
            position: 'fixed',
            top: `${dropdownDimentions.top + fixedTopSpace}px`,
            width: `${dropdownDimentions.width}px`,
            left: openToRight
              ? `${dropdownDimentions.left - optionsElement?.current?.getBoundingClientRect()?.width}px`
              : `${dropdownDimentions.left + fixedRightSpace}px`,
            opacity: 1,
          };
        } else {
          styles = { top: `${dropdownElement?.current?.getBoundingClientRect()?.height - 1}px`, opacity: 1 };
        }
        setDropdownStyles(styles);
      };
      createStyles();
    }
  }, [showDropdown, dropdownDimentions]);

  return (
    <div className={`position-relative ${showDropdown ? 'dropdown-open' : ''}`} ref={dropdownElement}>
      <button
        className={`general-button d-block w-100 mb-0 hour-select px-3 ${
          showDropdown ? 'hour-select-opendropdown' : ''
        } ${cutAtBottom ? 'cut-at-bottom' : ''} ${mainItemClass ?? ''} ${disabled ? 'disabled-hour-select' : ''} ${
          hideArrowDisabled ? 'hour-select-hidden-arrow' : ''
        }`}
        ref={mainItemElement}
        disabled={disabled}
        onClick={() => {
          if (!disabled && !hideArrowDisabled) {
            setShowDropdown(!showDropdown);
          }
        }}
      >
        {typeof mainItem === 'function' ? mainItem() : <span className='hidden-lines hidden-one-line'>{mainItem}</span>}
      </button>
      {!!nextIcon && <>{nextIcon()}</>}
      {showDropdown && (
        <>
          <div className='general-close-background' onClick={() => setShowDropdown(false)}></div>
          <div
            className={`frequency-dropdown general-dropdown ${
              overlapContent ? 'overlap-options' : ''
            } ${dropdownClass}`}
            style={dropdownStyles}
            ref={optionsElement}
          >
            {items ? items() : ''}
            {children}
          </div>
        </>
      )}
    </div>
  );
};

export default DropdownComponent;
